import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {Resource} from '../../../graphql/resources.datatypes';
import {gqlResource} from '../getResource.api';

export interface FixRoomResourceCapacityVars {
    id: number,
}

interface FixRoomResourceCapacityData {
    __typename?: string,
    fixRoomResourceCapacity: Resource
}

export const UPDATE_OPTION_VALUES_MUTATION = gql`
    mutation fixRoomResourceCapacity($id: Int!) {
        fixRoomResourceCapacity(id: $id) {
            ${gqlResource}
        }
    }
`;

export const fixRoomResourceCapacity = () => useMutation<FixRoomResourceCapacityData, FixRoomResourceCapacityVars>(
    UPDATE_OPTION_VALUES_MUTATION,
    {
        update: updateCacheByType('Resource'),
    }
);

export default fixRoomResourceCapacity;